import React, { FC } from 'react';
import { Card } from '~/components';
import { Typography } from 'antd';
import cx from 'classnames';
import styled from 'styled-components';
import { useDirection } from '~/hooks';
import { CardProps } from '~/components/Card';

interface Props {
  icon?: JSX.Element;
  title: string;
}

const PasswordResetSuccessPanel: FC<Props> = (props) => {
  const { icon, title, children } = props;
  const [direction] = useDirection();

  return (
    <StyledCard
      direction={direction}
      title={
        <div className="PasswordResetHeader">
          {icon && (
            <icon.type
              {...icon.props}
              className={cx(icon.props.className, 'PasswordResetHeader-Icon')}
            />
          )}
          <Typography.Text type="secondary">{title}</Typography.Text>
        </div>
      }
      expandable
      bordered
    >
      {children}
    </StyledCard>
  );
};

interface StyledCardProps extends CardProps {
  direction: 'ltr' | 'rtl';
}

const StyledCard = styled<FC<StyledCardProps>>(Card as any)`
  .PasswordResetHeader {
    display: flex;
    font-weight: normal;
  }

  .PasswordResetHeader-Icon {
    font-size: 24px;
    margin-left: ${({ direction }) => (direction === 'rtl' ? '5px' : '0px')};
    margin-right: ${({ direction }) => (direction === 'ltr' ? '5px' : '0px')};
  }

  .ant-card-head {
    min-height: unset;
  }
`;

export default PasswordResetSuccessPanel;
